<template>
  <div class="col s12">
    <div class="row no-margin">
      <div class="col s12">
        <span class="left-align title">{{ $t('views.switch') }} {{ railObject ? railObject.Name : '' }}</span>
      </div>
    </div>

    <div class="row no-margin">
      <div class="col s6">N: {{ railObject ? railObject.LegendOptionDirectionNormal : '' }}</div>
      <div class="col s6">R: {{ railObject ? railObject.LegendOptionDirectionReverse : '' }}</div>
    </div>
    <div class="row no-margin">
      <div class="col s5 status"><strong>{{ $t('views.dashboard.selector.monitorstatus') }}:</strong></div>
      <div class="col s6 status monitorStatus" @click="resetStatus">
        <div v-if="monitorStatusId === 1" class="info-icons-div">
          <i class="material-icons switch-info-icon" :style="{'color' : monitorStatusColor }">check</i>
        </div>
        <div v-else-if="monitorStatusId === 2" class="info-icons-div">
          <img class="switch-info-icon" src="../../assets/switch/Warning icon.svg" width="24">
        </div>
        <div v-else-if="monitorStatusId === 3" class="info-icons-div">
          <img class="switch-info-icon" src="../../assets/switch/Alarm icon.svg" width="24">
        </div>
        <span class="body2" :style="{'color' : monitorStatusColor }">{{ monitorstatusDescription }}</span>
        <reset-status
          v-bind:switch-object.sync="railObject"
          :monitorStatusId.sync="monitorStatusId"
          :show-modal.sync="showResetStatus">
        </reset-status>
      </div>
    </div>
    <div class="row no-margin">
      <div class="col s5 status"><strong>{{ $t('views.dashboard.selector.operationalstatus') }}:</strong></div>
      <div class="col s6 status operationalStatus" @click="editOperationalStatus">
        <div v-if="operationModeId === 5" class="info-icons-div">
          <i class="material-icons switch-info-icon status-maintenance">build</i>
        </div>
        <div v-else-if="operationModeId === 1" class="info-icons-div">
          <i class="material-icons switch-info-icon status-normal">check</i>
        </div>
        <div v-else></div>
        <span class="body1" v-bind:class="{ 'status-maintenance': operationModeId === 5 }">{{ operationalStatusDescription }}</span><br />
        <operational-status
                  :switch-object.sync="railObject"
                  :operationModeId.sync="operationModeId"
                  :show-modal.sync="showEditOpModeStatus">
                </operational-status>
      </div>
    </div>
    <!--
    <div class="row no-margin">
      <div class="col s5 status"><strong>{{ $t('views.switch.lastmaintenancedate') }}:</strong></div>
      <div class="col s6 status lastMaintenance">
        <div class="info-icons-div">
          <i class="material-icons switch-info-icon" style="color: dodgerblue">build</i>
        </div>
        <span class="body1">{{ lastMaintenanceDateTime }}</span>
      </div>
    </div>
    -->

    <div class="row no-margin">
      <div class="col s5 status"><strong>{{ $t('views.switch.lastmaintenancedate') }}:</strong></div>
      <div class="col s6 status lastMaintenance">
        <div v-if="maintenanceStatus && maintenanceStatus.LastMaintDateTime !== null">
          {{  formatDateTime(maintenanceStatus.LastMaintDateTime) }}
        </div>
        <div v-else>
          Unknown
        </div>
      </div>
    </div>

    <div class="row no-margin">
      <div class="col s5 status">
        <strong>Next maintenance:</strong>
      </div>
      <div class="col s6 status" v-show="maintenanceStatus">
        <div v-if="maintenanceStatus && maintenanceStatus.LastMaintDateTime !== null && maintenanceStatus.nextMaintDate !== null">
          {{  formatDateTime(maintenanceStatus.nextMaintDate) }}
        </div>
        <div v-else>
          Unknown
        </div>
      </div>
    </div>

    <div class="row no-margin">
      <div class="col s5 status">
        <strong>Actual movements:</strong>
      </div>
      <div class="col s6 status" v-show="maintenanceStatus">
        <div v-if="maintenanceStatus && maintenanceStatus.LastMaintDateTime !== null">
          {{ maintenanceStatus.ActualMovements }}
        </div>
        <div v-else>
          Unknown
        </div>
      </div>
    </div>

    <hr>
    <div class="row no-margin-bottom">
      <div class="col s12">
        <span class="body2-menu"><strong>{{ $t('views.switch.components') }}:</strong></span>
      </div>
    </div>
    <div class="row no-margin-bottom">
      <div class="col s12">
        <ul class="componenttree">
          <li v-for="(item, index) in childObjects" :key="index">
            <span class="componenttree-span treeItemNotSelectable"
                  :class="{ 'active-object': item.isActive }">{{ item.Name }}</span>
            <ul v-if="item.hasChildren">
              <li v-for="(jtem, jndex) in item.childObjects" :key="index + '-' + jndex">
                <span class="componenttree-span treeItemNotSelectable"
                      :class="{ 'active-object': jtem.isActive }">{{ jtem.Name }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="row no-margin-bottom">
      <div class="col s12" style="padding-top: 5px;">
        <strong>{{ $t('views.switch.location') }}:</strong>
        <span class="right body1">{{ railObjectCoordinatesString }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import MiniMap from './map'
import OperationalStatus from './OperationalStatus'
import ResetStatus from './ResetStatus'
import moment from 'moment'
import MaintenanceStatusService from '@/services/MaintenanceStatusService'

export default {
  name: 'SwitchInfo',
  props: {
    railObject: {
      required: true
    },
    childObjects: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  components: {
    MiniMap: MiniMap,
    OperationalStatus: OperationalStatus,
    ResetStatus: ResetStatus
  },
  data () {
    return {
      relatedObjects: [],
      // showEditLastMaintDate: false,
      showEditOpModeStatus: false,
      showResetStatus: false,
      maintenanceStatus: undefined
    }
  },
  computed: {
    railObjectName: function () {
      if (this.railObject) {
        return this.railObject.Name
      } else {
        return ''
      }
    },
    monitorStatusId: {
      get () {
        if (this.railObject) {
          return this.railObject.MonitorStatusId
        } else {
          return 0
        }
      },
      set (val) {
        this.railObject.MonitorStatusId = val
      }
    },
    monitorstatusDescription () {
      if (this.railObject) {
        switch (this.railObject.MonitorStatusId) {
          case 1:
            return this.$t('ok')
          case 2:
            return this.$t('warning')
          case 3:
            return this.$t('error')
          default:
            return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    monitorStatusColor () {
      if (this.railObject) {
        switch (this.railObject.MonitorStatusId) {
          case 1:
            return '#1DB85F'
          case 2:
            return '#FFA842'
          case 3:
            return '#C91414'
          default:
            return 'grey'
        }
      } else {
        return 'grey'
      }
    },
    operationModeId: {
      get () {
        if (this.railObject) {
          return this.railObject.OperationModeId
        } else {
          return 0
        }
      },
      set (val) {
        this.railObject.OperationModeId = val
      }
    },
    operationalStatusDescription () {
      if (this.railObject) {
        switch (this.railObject.OperationModeId) {
          case 1:
            return this.$t('operational')
          case 5:
            return this.$t('maintenance')
          default:
            return this.$t('operational')
        }
      } else {
        return this.$t('unknown')
      }
    },
    lastMaintenanceDateTime () {
      if (this.railObject) {
        if (this.railObject.LastMaintenanceDateTime) {
          return moment(this.railObject.LastMaintenanceDateTime).format('YYYY-MM-DD')
        } else {
          return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    miniMapCoordsStatus () {
      if (this.railObject) {
        if (this.railObject.Latitude && this.railObject.Longtitude) {
          const latLong = [parseFloat(this.railObject.Latitude), parseFloat(this.railObject.Longtitude)]
          return {
            latLong: latLong,
            status: this.railObject.MonitorStatusId,
            opmode: this.railObject.OperationModeId
          }
        } else {
          return {latLong: [0, 0], status: this.railObject.MonitorStatusId, opmode: this.railObject.OperationModeId}
        }
      } else {
        return null
      }
    },
    railObjectCoordinatesString () {
      if (this.railObject) {
        if (this.railObject.Latitude && this.railObject.Longtitude) {
          return this.railObject.Latitude.toString() + ', ' + this.railObject.Longtitude.toString()
        } else {
          return this.$t('unknown')
        }
      } else {
        return ''
      }
    }
  },
  mounted: function () {
    this.getMaintenanceStatus()
  },
  watch: {
    railObject () {
      this.getMaintenanceStatus()
    }
  },
  methods: {
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('DD-MM-YYYY HH:mm')
    },
    getMaintenanceStatus: async function () {
      await MaintenanceStatusService.GetMaintenanceStatus(this.railObject.ComplexId).then(result => {
        for (let i = 0; i < result.length; i++) { // Find the right object in the array
          if (result[i].RailObjectID === this.railObject.RailObjectId) {
            this.maintenanceStatus = result[i]
            break
          }
        }
      })
    },
    // editMaintenanceDate () {
    //   this.showEditLastMaintDate = true
    // },
    // hideLastMaintenanceDate () {
    //   this.showEditLastMaintDate = false
    // },
    editOperationalStatus () {
      this.showEditOpModeStatus = true
    },
    hideAllModals () {
      this.showEditOpModeStatus = false
      this.showResetStatus = false
    },
    resetStatus () {
      this.showResetStatus = true
    }
    //
  }
}

</script>
<style scoped>
  .operationalStatus, .monitorStatus {
    cursor: pointer;
  }

  .title {
    font-family: Roboto, Arial, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.87);
  }

  .status {
    height: 34px;
    width: 100%;
    padding: 5px 15px;
    margin: 0px 5px;
  }

  .info-icons-div {
    display: inline-block;
    padding-right: 5px;
  }

  ul.componenttree ul {
    margin-left: 10px;
  }

  ul.componenttree li {
    margin: 0;
    padding: 0 7px;
    line-height: 20px;
    font-family: Roboto;
    color: rgba(0, 0, 0, 0.87);
    border-left: 1px solid rgb(100, 100, 100);
  }

  ul.componenttree li:last-child {
    border-left: none;
  }

  ul.componenttree li:before {
    position: relative;
    top: -0.3em;
    height: 1em;
    width: 12px;
    color: white;
    border-bottom: 1px solid rgb(100, 100, 100);
    content: "";
    display: inline-block;
    left: -7px;
  }

  ul.componenttree li:last-child:before {
    border-left: 1px solid rgb(100, 100, 100);
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/SwitchInfoPopOver.vue